module.exports = __webpack_public_path__ + "real-estate.ba7ffc39282a2f067573.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/INMOGR/Desktop/Angular Project/src/assets/fonts/line-icons-pro/real-estate/webfont/real-estate.ttf
// module id = ../../../../../src/assets/fonts/line-icons-pro/real-estate/webfont/real-estate.ttf
// module chunks = styles